<template>
  <v-layout row wrap>
      <v-card>
          <v-card-text>
               <PayPal
  amount="10.00"
  currency="USD"
  :client="credentials"
  env="sandbox">
</PayPal>

          </v-card-text>
      </v-card>
</v-layout>
</template>
<script>

import PayPal from 'vue-paypal-checkout';


export default {
  components: {
    PayPal
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data () {
    return {
      credentials: {
        sandbox: 'AVnhqOyru5OY3WTwsPdtSQKN9Oq1yph6GB71eoRelFct77ZemInjrXE5e50CG3BbMb-Ko1cKMWkiAHUG',
        production: '<production client id>'
      }
    }
  }
}
</script> 
